import * as Sentry from '@sentry/browser';
import BuildSettings from 'APP_ROOT/components/buildSettings';

const REPORTING_ENABLED = process.env.NODE_ENV !== 'development' && process.env.REACT_APP_DISABLE_SENTRY !== 'true';

export function initialize() {
    if (REPORTING_ENABLED) {
        Sentry.init({
            dsn: process.env.REACT_APP_SENTRY_DSN,
            release: `raven-webapp@${BuildSettings.buildId}`,
            environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
        });
    }
}

export function setUserId(id) {
    Sentry.configureScope((scope) => {
        scope.setUser({ id });
    });
}

export function setAccountType(accountType) {
    Sentry.configureScope((scope) => {
        scope.setTag('account_type', accountType);
    });
}

export function setChannelId(channelId) {
    Sentry.configureScope((scope) => {
        scope.setTag('channel_id', channelId);
    });
}

export function setChannelCode(channelCode) {
    Sentry.configureScope((scope) => {
        scope.setTag('channel_code', channelCode);
    });
}

export function error(err) {
    if (!REPORTING_ENABLED) {
        console.error(err);
        return;
    }
    if (typeof err === 'string') {
        Sentry.captureMessage(err);
    } else {
        Sentry.captureException(err);
    }
}

const LEVELS = ['fatal', 'error', 'warning', 'info', 'debug'];

function log({ category, message, data }, level = 'debug') {
    if (!REPORTING_ENABLED) {
        console.log(level, category, message, data);
        return;
    }
    if (!LEVELS.includes(level)) level = 'debug';
    Sentry.addBreadcrumb({
        category,
        message,
        data,
        level
    });
};

export function logd(args) {
    log(args, 'debug');
};

export function logi(args) {
    log(args, 'info');
};

export function logw(args) {
    log(args, 'warn');
};

export function loge(args) {
    log(args, 'error');
};
